import NameCell from 'components/UserTable/Cells/NameCell';
import JointCell from 'components/UserTable/Cells/JointCell';
import LastLoginCell from 'components/UserTable/Cells/LastLoginCell';
import StatusCell from 'components/UserTable/Cells/StatusCell';
import DefaultCell from 'components/UserTable/Cells/DefaultCell';
import TeamCell from 'components/UserTable/Cells/TeamCell';
import RoleCell from 'components/UserTable/Cells/RoleCell';
import OverviewCell from 'components/UserTable/Cells/OverviewCell';
import validators from 'validator';
import Input from 'components/UserTable/Inputs/Input';
import Avatar from 'components/UserTable/Inputs/Avatar';
import NameInput from 'components/UserTable/Inputs/NameInput';
import PasswordInput from 'components/UserTable/Inputs/PasswordInput';
import TeamSelect from 'components/UserTable/Inputs/TeamSelect';
import RoleSelect from 'components/UserTable/Inputs/RoleSelect';
import messages from '../messages';

export default Object.freeze({
  headers: {
    id: {
      index: 0,
      name: 'ID',
      prop: 'uniqueId',
      sticky: true,
      style: {
        minWidth: 120,
      },
      component: DefaultCell,
      componentName: 'DefaultCell',
      componentProps: {},
    },
    team: {
      index: 1,
      name: 'TEAM',
      sticky: true,
      style: {
        minWidth: 100,
      },
      component: TeamCell,
      componentName: 'TeamCell',
      componentProps: {},
    },
    name: {
      index: 2,
      name: 'NAME',
      sticky: true,
      style: {
        minWidth: 220,
      },
      component: NameCell,
      componentName: 'NameCell',
      componentProps: {},
    },
    email: {
      index: 3,
      name: 'EMAIL',
      sticky: true,
      style: {
        minWidth: 272,
      },
      prop: 'email',
      direciton: 'right',
      component: DefaultCell,
      componentName: 'DefaultCell',
      componentProps: {},
    },
    role: {
      index: 4,
      name: 'ROLE',
      sticky: true,
      style: {
        minWidth: 174,
      },
      component: RoleCell,
      componentName: 'RoleCell',
      componentProps: {},
    },
    joint: {
      index: 5,
      name: 'JOINT',
      style: {
        minWidth: 160,
      },
      component: JointCell,
      componentName: 'JointCell',
      componentProps: {},
    },
    overview: {
      index: 6,
      name: 'OVERVIEW',
      style: {
        minWidth: 320,
      },
      component: OverviewCell,
      componentName: 'OverviewCell',
      componentProps: {},
    },
    lastLogin: {
      index: 7,
      name: 'LAST LOGIN',
      style: {
        minWidth: 160,
      },
      component: LastLoginCell,
      componentName: 'LastLoginCell',
      componentProps: {},
    },
    status: {
      index: 8,
      name: 'STATUS',
      style: {
        minWidth: 140,
      },
      component: StatusCell,
      componentName: 'StatusCell',
      componentProps: {
        activeName: 'activate',
        unActiveName: 'deactivate',
      },
    },
  },
  team: {
    name: 'READER',
    users: [
      {
        _id: 1,
        uniqueId: '000-000-001',
        location: '615afc94899dd8828faebd8a',
        avatar:
          'https://upload.jidipi.com/avatars/users/default/avatar-m-05%402x.png',
        firstName: 'test',
        lastName: 'test',
        email: 'test@test.com',
        createdAt: '2022-03-21T11:34:35.567Z',
        lastLoginAt: '2022-03-21T11:34:35.567Z',
        hours: '23h 20m 40s',
        visited: '3,829',
        saved: '123',
        isActive: true,
        roles: ['62283bd96183fd25bbd5cc27'],
      },
      {
        _id: 2,
        uniqueId: '000-000-002',
        location: '615afc94899dd8828faebd8a',
        avatar:
          'https://upload.jidipi.com/avatars/users/default/avatar-m-05%402x.png',
        firstName: 'test1',
        lastName: 'test1',
        email: 'test1@test1.com',
        createdAt: '2022-03-21T11:34:35.567Z',
        lastLoginAt: '2022-03-21T11:34:35.567Z',
        hours: '23h 20m 40s',
        visited: '3,829',
        saved: '321',
        isActive: true,
        roles: ['62283bd96183fd25bbd5cc27'],
      },
    ],
  },
  inputs: {
    right: {
      id: {
        index: 0,
        component: Input,
        componentName: 'Input',
        componentProps: {
          prop: 'uniqueId',
          disabled: true,
          custom: true,
          placeholder: 'ID',
        },
      },
      team: {
        index: 1,
        name: 'TEAM',
        component: TeamSelect,
        componentName: 'TeamSelect',
        type: 'select',
        componentProps: {
          prop: 'teamName',
        },
      },
      roles: {
        index: 2,
        name: 'ROLES',
        component: RoleSelect,
        componentName: 'RoleSelect',
        type: 'select',
        componentProps: {
          prop: 'roles',
          isDisabled: true,
        },
      },
    },
    middle: {
      avatar: {
        index: 3,
        name: 'Avatar',
        component: Avatar,
        componentName: 'Avatar',
        componentProps: {},
      },
    },
    left: {
      name: {
        index: 4,
        name: 'NAME',
        component: NameInput,
        componentName: 'NameInput',
        componentProps: {},
      },
      email: {
        index: 5,
        name: 'EMAIL',
        component: Input,
        componentName: 'Input',
        componentProps: {
          prop: 'email',
          placeholder: 'EMAIL',
          custom: true,
        },
      },
      password: {
        index: 6,
        name: 'PASSWORD',
        component: PasswordInput,
        componentName: 'PasswordInput',
        componentProps: {
          prop: 'password',
          custom: true,
        },
      },
    },
  },
  unEditable: false,
  noContextMenu: false,
  isStaff: true,
  initialRow(team) {
    return {
      _id: 'initial_user',
      uniqueId: '',
      location: '',
      firstName: '',
      lastName: '',
      email: '',
      registrationDate: '',
      avatar: '',
      logoId: '',
      roleId: '',
      isActive: false,
      teamId: team._id,
    };
  },
  validations: {
    firstName: {
      validate: (value) => validators.isLength(value, {min: 4, max: 50}),
      error: `${messages.enterValid} First Name`,
    },
    lastName: {
      validate: (value) => validators.isLength(value, {min: 4, max: 50}),
      error: `${messages.enterValid} Last Name`,
    },
    email: {
      validate: (value) => validators.isEmail(value),
      error: `${messages.enterValid} Email`,
    },
    password: {
      validate: (value) => validators.isLength(value, {min: 8, max: 20}),
      error: `${messages.enterValid} Password`,
    },
  },
  firstInitItemState(team) {
    const item = {
      password: '',
      firstName: '',
      lastName: '',
      email: '',
      avatar: '',
      logoId: '',
      team: '',
      teamName: team.name,
      roles: [],
    };
    return item;
  },
  selectExistingUser(role, user, teamId) {
    user.roles.push(role);
    return {
      ...user,
      teamId,
      isExistingUser: true,
      roles: user.roles,
    };
  },
  resetOnSelectItem(selectedItem, team) {
    return {
      uniqueId: selectedItem.uniqueId,
      firstName: selectedItem.firstName,
      lastName: selectedItem.lastName,
      avatar: selectedItem.avatar,
      email: selectedItem.email,
      logoId: selectedItem.logoId,
      teamName: team.name,
      _id: selectedItem._id,
      userId: selectedItem._id,
      username: selectedItem.email,
      teamId: team._id,
      roles: selectedItem.roles,
      isExistingUser: selectedItem.isExistingUser,
    };
  },
  onAddMemberItemRemap(item, team) {
    const updatedItem = {
      ...item,
      // roles: [itemRole],
      teamId: item.teamId || team._id,
      username: item.email,
    };
    if (updatedItem._id === 'new_user') {
      delete updatedItem._id;
      delete updatedItem.userId;
    }
    return updatedItem;
  },
  onConfirmDeleteMemberItemRemap(item, team) {
    return {
      _id: item._id,
      userId: item._id,
      // roles: item.roles,
      teamName: item.teamName,
      username: item.email,
      isDeleted: true,
      logoId: item.logoId,
      avatar: item.avatar,
      firstName: item.firstName,
      lastName: item.lastName,
      teamId: team._id,
    };
  },
  validationErrors: {
    firstName: {
      isValid: false,
    },
    lastName: {
      isValid: false,
    },
    email: {
      isValid: false,
    },
    password: {
      isValid: false,
    },
  },
});
